import { render, staticRenderFns } from "./products-table.vue?vue&type=template&id=bec9329c&scoped=true&"
import script from "./products-table.vue?vue&type=script&lang=js&"
export * from "./products-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec9329c",
  null
  
)

export default component.exports